import { c as _c } from "react/compiler-runtime";
import { SkipLink } from "@repo/design-system/components/ui/skip-link";
import type { ReactNode } from "react";
import FooterFromRegistry from "./footer-from-registry";
import HeaderMainFromRegistry from "./header-main-from-registry";
export default function PageSkeleton(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SkipLink />;
    t2 = <HeaderMainFromRegistry />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <main className="w-full min-w-0" id="main-content" tabIndex={-1}>{children}</main>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FooterFromRegistry />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className="relative flex min-h-screen flex-col">{t1}{t2}{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}